import CreateProjectContainer from "../../../components/applications/project/createProject";

const CreateProject = () => {
  return <CreateProjectContainer />;
};

export default CreateProject;
